import React from "react";
import { C } from "../theme";
import Button from "./Button";

/**
 * "What's New" sheet. Shown once after a user signs in following a deploy that
 * carries curated release notes (see src/data/changelog.js). The caller decides
 * when to open it and records the acknowledged version on close.
 */
export default function WhatsNewModal({ open, entries = [], onClose }) {
  if (!open || !entries.length) return null;

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background: "rgba(4,8,15,0.72)",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    zIndex: 12000,
    padding: 0,
  };

  const sheetStyle = {
    width: "100%",
    maxHeight: "92%",
    overflowY: "auto",
    background: C.cardBg,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTop: `1px solid ${C.border}`,
    boxShadow: "0 -10px 40px rgba(0,0,0,0.5)",
    padding: "18px 18px calc(20px + env(safe-area-inset-bottom, 0px))",
    color: C.white,
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div
        style={sheetStyle}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="What's new"
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
          <span aria-hidden style={{ fontSize: 18 }}>✦</span>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>What's New in THE 99</h2>
        </div>
        <p style={{ margin: "2px 0 16px", fontSize: 13, color: C.muted, lineHeight: 1.5 }}>
          Here's what changed since you were last here.
        </p>

        {entries.map((entry) => (
          <div
            key={entry.version}
            style={{
              borderTop: `1px solid ${C.border}`,
              paddingTop: 14,
              marginBottom: 14,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <div style={{ fontSize: 15, fontWeight: 800, color: C.white }}>
                {entry.title}
              </div>
              {entry.date ? (
                <div style={{ fontSize: 10, color: C.muted, whiteSpace: "nowrap" }}>
                  {entry.date}
                </div>
              ) : null}
            </div>
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {entry.notes.map((note, idx) => (
                <li
                  key={idx}
                  style={{ fontSize: 13, color: C.sand, lineHeight: 1.55, marginBottom: 4 }}
                >
                  {note}
                </li>
              ))}
            </ul>
          </div>
        ))}

        <Button
          variant="primary"
          fullWidth
          onClick={onClose}
          style={{ marginTop: 4 }}
        >
          Got it
        </Button>
      </div>
    </div>
  );
}
